import React from "react";
import vactor from "../../../assets/svg/404error.svg";

function Error() {
  return (
    <div className="w-full h-screen flex flex-col  items-center justify-center ">
      <img
        src={vactor}
        style={{ aspectRatio: "3/2" }}
        className=" h-[70%]  object-contain"
        alt="error-vactor"
      />

      <div className=" text-center  ">
        <h1 className=" text-[32px] font-bold  ">
          You have encountered an error !
        </h1>
        <p className="text-lg text-[#6C757D]">
          The page you’re looking for doesn’t exist or has been moved.
        </p>

        <button className="btn-primary  font-medium w-[190px] mt-[30px]   ">
          Go back
        </button>
      </div>
    </div>
  );
}

export default Error;
